export interface ParticipantBadge {
  initial: string;
  color: string;
}

interface ParticipantBadgesProps {
  people: ParticipantBadge[];
  size?: number;
  /** "outline": white circle, colored initial — for a badge sitting on a colored/saturated
   * background (calendar grid pills), where a solid color badge could blend in. "solid":
   * colored circle, white initial — for a badge sitting on a plain/neutral row background
   * (agenda list, search results), which reads more like a normal avatar. */
  variant?: "outline" | "solid";
}

/** Small circular badges with each participant's initial. Deliberately not just a colored
 * dot: a person's color and their event's type color can land in the same hue family (e.g. a
 * garnet person on a red "Game" background), which makes a plain dot vanish. The initial is
 * also a second, color-independent way to tell who's involved. */
export function ParticipantBadges({ people, size = 15, variant = "outline" }: ParticipantBadgesProps) {
  if (people.length === 0) return null;
  return (
    <span className="flex shrink-0 items-center -space-x-1">
      {people.map((p, i) => (
        <span
          key={i}
          className="flex shrink-0 items-center justify-center rounded-full font-bold"
          style={{
            width: size,
            height: size,
            fontSize: size * 0.58,
            lineHeight: 1,
            backgroundColor: variant === "solid" ? p.color : "white",
            color: variant === "solid" ? "white" : p.color,
            boxShadow: variant === "solid" ? "0 0 0 1.5px white" : "0 0 0 1px rgba(0,0,0,0.15)",
          }}
        >
          {p.initial}
        </span>
      ))}
    </span>
  );
}
